"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.create = exports.fetch = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const subCategoriesService_1 = require("./service/subCategoriesService");
const Env_1 = require("../../utils/tsUtils/Env");
exports.fetch = (0, toolkit_1.createAsyncThunk)("subCategories/fetch", (fetchPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const subcategoriesService = new subCategoriesService_1.SubCategoriesService(Env_1.APIPATHENV);
        const response = yield subcategoriesService.fetch(fetchPayload);
        return response;
    }
    catch (err) {
        throw new Error("Error in fetching subCategories");
    }
}));
exports.create = (0, toolkit_1.createAsyncThunk)("subCategories/create", (createPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const subcategoriesService = new subCategoriesService_1.SubCategoriesService(Env_1.APIPATHENV);
        const response = yield subcategoriesService.create(createPayload);
        return response;
    }
    catch (err) {
        throw new Error("Error in creating subCategories");
    }
}));
exports.update = (0, toolkit_1.createAsyncThunk)("subCategories/update", (createPayload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const subcategoriesService = new subCategoriesService_1.SubCategoriesService(Env_1.APIPATHENV);
        const response = yield subcategoriesService.update(createPayload);
        return response;
    }
    catch (err) {
        throw new Error("Error in updating subCategories");
    }
}));
